<template>
  <div class="dashboard">
    <div class="dashboardpage" :style="`height:${height - 110}px`">
      <dashTopPptList v-show="showPPTList" :changePage="changePage" />
      <div v-if="session?.video?.[getPage._id]"></div>
      
      <!-- Normal Dashboard View -->
      <div v-else-if="!showFullAnswer" :class="`dash-second ${((showResponse && getQuestion && !isStudentPaced) || isLockPage) && 'red-dash-border'}`">
        <div class="dash-second-left dash-border">
          <pptDetail :showLogo="true" />
          <DashboardMeterial />
          <div :class="`shouqi ${!showPPTList && 'zhankai'} ppt-shouqi`" @click="togglePPTList"></div>
        </div>
        <template v-if="getQuestion && getQuestion.type !== 'website'">
          <div class="dash-second-right">
            <DashResAndStudents :showResponse="showResponse" :responseList="responseContentList" />
          </div>
        </template>
      </div>

      <!-- Expanded Responses View (Screenshots 1 & 2) -->
      <div v-else class="expanded-responses-card">
        <div :class="`shouqi ${!showPPTList && 'zhankai'} ppt-shouqi`" @click="togglePPTList"></div>
        <div class="expanded-top-header">
          <div class="header-left">
            <span class="response-title">Student Responses</span>
            <span class="answered-ratio">{{ answeredCount }}/{{ totalStudentsCount }} answered</span>
          </div>
          <button class="expanded-close-btn" title="Close" @click="closeExpandedView">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="expanded-body">
          <div class="expanded-left-responses">
            <teacherIndexItem
              v-if="getQuestion"
              :flag_1="true"
              :currentAnswerCount="currentAnswerCount"
              :textList="responseContentList"
              :isDash="false" />
          </div>
          <div class="expanded-right-roster">
            <DashGroupStudents />
          </div>
        </div>
      </div>

      <TipsList v-if="overviewModalVisiable" />
    </div>
  </div>
</template>

<script>
import TipsList from '../common/tipsList.vue'
import DashboardMeterial from './dashboardMeterial.vue'
import DashResAndStudents from './dashResAndStudents.vue'
import teacherIndexItem from './Index.vue'
import dashTopPptList from './dash/dashTopPptList.vue'
import DashSwitchHeader from './dash/dashSwitchHeader.vue'
import DashGroupStudents from './dashGroupStudents.vue'
import {mapState, mapGetters} from 'vuex'
import pptDetail from '../pptDetail.vue'
// import VideoPlayer from '@/components/teacher/interactive-video/VideoPlayer.vue'

export default {
  components: {DashSwitchHeader, teacherIndexItem, DashboardMeterial, TipsList, DashResAndStudents, dashTopPptList, DashGroupStudents, pptDetail},
  props: {
    currentAnswerCount: {
      type: Number,
      default: 0,
    },
    responseContentList: {
      type: Array,
      function() {
        return []
      },
    },
    responsePercentage: {
      type: Array,
      function() {
        return []
      },
    },
    overviewModalVisiable: {
      type: Boolean,
      default: false,
    },
    changePage: {
      type: Function,
    },
    session: {
      type: Object,
    },
    getResponeCount: {
      type: Function,
    },
  },
  data() {
    return {
      height: window.winHeight,
      showPPTList: true,
      padTab: 2,
    }
  },
  computed: {
    ...mapState('teacher', ['rooms', 'studentList']),
    ...mapState({
      currentPageIndex: (state) => state.student.currentPageIndex,
    }),
    ...mapGetters(['getPage', 'isStudentPaced', 'getQuestion']),
    ...mapGetters('student', ['currentPageAnswerList']),
    showFullAnswer() {
      return this.$store.state.teacher.showMoreMap[this.currentPageIndex] ?? false
    },
    showResponse() {
      return this.$store.getters['teacher/isResponseShow'](this.currentPageIndex)
    },
    isLockPage() {
      return this.$store.getters['teacher/isLocked'](this.currentPageIndex)
    },
    tpClass() {
      return this.showResponse && this.getQuestion.type !== 'website' && !this.isStudentPaced ? 'content_parent content_parent--border' : 'content_parent'
    },
    answeredCount() {
      const answeredSet = new Set()
      if (this.currentPageAnswerList && this.currentPageAnswerList.length) {
        for (const item of this.currentPageAnswerList) {
          const id = item.uid || item.user_id || item._id
          if (id) answeredSet.add(id)
        }
      }
      return answeredSet.size
    },
    totalStudentsCount() {
      if (this.rooms?.members && this.rooms.members.length > 0) {
        return Math.max(this.rooms.members.length, this.answeredCount)
      }
      if (this.studentList && this.studentList.length > 0) {
        return Math.max(this.studentList.length, this.answeredCount)
      }
      if (this.session?.students && this.session.students.length > 0) {
        return Math.max(this.session.students.length, this.answeredCount)
      }
      if (this.session?.regNum) {
        return Math.max(this.session.regNum, this.answeredCount)
      }
      return this.answeredCount || 0
    },
  },
  created() {},
  mounted() {},
  methods: {
    closeExpandedView() {
      this.$store.dispatch('teacher/showMoreBtn', this.currentPageIndex)
    },
    showCurrentStudent() {
    },
    togglePPTList() {
      this.showPPTList = !this.showPPTList
    },
    changePadTab(index) {
      this.padTab = index
    },
  },
}
</script>

<style>
@import url(../../assets/css/dashpage.css);
</style>
